import { dayjs } from "@holibob-packages/dayjs";

import { CancellationPenalty } from "./types";

export type ComputePersonListEffectiveCancellationPenalty = CancellationPenalty & {
    totalCurrency: string;
    totalAmount: number;
};
export function computePersonListEffectiveCancellationPenalty(
    penaltyList: ComputePersonListEffectiveCancellationPenalty[]
): CancellationPenalty | undefined {
    // TODO: this is ugly, does not support different currencies and cancellation types
    const firstEffectivePenalty = penaltyList[0];

    if (!firstEffectivePenalty) {
        return;
    }

    const effectiveRelativeTo = firstEffectivePenalty.relativeTo;
    const effectiveCurrency = firstEffectivePenalty.totalCurrency;

    let effectiveDuration = firstEffectivePenalty.duration ?? null;
    let effectiveRefundAmount = 0;

    for (const penalty of penaltyList) {
        const { relativeTo, duration, type, totalCurrency, totalAmount } = penalty;

        // Cannot combine different types of cancellation penalties
        if (effectiveRelativeTo !== relativeTo) {
            return;
        }

        // Cannot combine currencies of cancellation penalties
        if (totalCurrency !== effectiveCurrency) {
            return;
        }

        // Compute effective duration as the minimum duration
        if (duration) {
            effectiveDuration =
                !effectiveDuration ||
                dayjs.duration(duration).asMilliseconds() < dayjs.duration(effectiveDuration).asMilliseconds()
                    ? duration
                    : effectiveDuration;
        }

        // compute amount
        if (type === "ABSOLUTE") {
            // Cannot combine different refund amount currencies is not supported
            if (penalty.amountCurrency !== effectiveCurrency) {
                return;
            }
            // Cannot combine refund type
            if (penalty.amountType === "REFUND") {
                effectiveRefundAmount += penalty.amount;
            } else {
                // CHARGE
                effectiveRefundAmount += totalAmount - penalty.amount;
            }
        } else {
            effectiveRefundAmount += (totalAmount * penalty.refundPercentage) / 100;
        }
    }

    // Merge cancellation penalties into one based on ABSOLUTE
    return {
        type: "ABSOLUTE",
        amountType: "REFUND",
        amount: parseFloat(effectiveRefundAmount.toFixed(2)),
        amountCurrency: effectiveCurrency,
        relativeTo: effectiveRelativeTo,
        duration: effectiveDuration,
    };
}
